import React, { useMemo} from 'react';
import { motion} from 'framer-motion';
import BranchPath from '../BranchPath';

import '@leenguyen/react-flip-clock-countdown/dist/index.css';
import img1 from "../assets/fotos-dye/img1.webp"
import img2 from "../assets/fotos-dye/img2.webp"
import img3 from "../assets/fotos-dye/img3.webp"
import img4 from "../assets/fotos-dye/img4.webp"
import img5 from "../assets/fotos-dye/img5.webp"
import img6 from "../assets/fotos-dye/img6.webp"
import img7 from "../assets/fotos-dye/img7.webp"
import img8 from "../assets/fotos-dye/img8.webp"
import img9 from "../assets/fotos-dye/img9.webp"
import img10 from "../assets/fotos-dye/27.webp"
import img11 from "../assets/fotos-dye/28.webp"
import anillo from "../assets/fotos-dye/anillo.webp"
import anillo5 from "../assets/fotos-dye/anillo5.webp"
import anillo4 from "../assets/fotos-dye/anillo4.webp"

function NuestraHistoria() {
    

  const storyPhotos = [
  { id: 1, src: img11, caption: "Nuestro primer viaje" },
  { id: 2, src: img10, caption: "Nuestro primer viaje" },
  { id: 3, src: img1, caption: "Nuestro primer viaje" },
  { id: 4, src: img2, caption: "Nuestro primer viaje" },
  { id: 5, src: img3, caption: "Nuestro primer viaje" },
  { id: 6, src: img4, caption: "Nuestro primer viaje" },
  { id: 7, src: img5, caption: "Nuestro primer viaje" },
  { id: 8, src: img6, caption: "Nuestro primer viaje" },
  { id: 9, src: img7, caption: "Nuestro primer viaje" },
  { id: 10, src: img8, caption: "Nuestro primer viaje" },
  { id: 11, src: img9, caption: "Nuestro primer viaje" },
  { id: 12, src: anillo4, caption: "Nuestro primer viaje" },
  { id: 13, src: anillo5, caption: "Nuestro primer viaje" },
  { id: 14, src: anillo, caption: "Nuestro primer viaje" },
];

const INSPIRATIONAL_QUOTE = "“El amor no se trata de mirar el uno al otro, sino de mirar juntos en la misma dirección.”";
// 1. Generar aleatoriedad memorizada.
  // Calculamos rotaciones y desplazamientos ligeros una sola vez para que no "bailen" al renderizar.
  const randomTransforms = useMemo(() => {
    return storyPhotos.map((_, index) => {
      const isLast = index === storyPhotos.length - 1;
      // La última foto (la de hasta arriba) la queremos más derecha.
      // Las otras tendrán más rotación (-15 a 15 grados) y desplazamiento.
      return {
        rotation: isLast ? (Math.random() * 4 - 2) : (Math.random() * 60 - 15), 
        xOffset: isLast ? 0 : (Math.random() * 40 - 20),
        yOffset: isLast ? 0 : (Math.random() * 40 - 20),
      };
    });
  }, []);
  // 2. Definir Variantes de Animación

  // Variante del contenedor (El director de orquesta)
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        // Stagger: Retrasa la animación de cada hijo consecutivamente
        staggerChildren: 1.3,
        delayChildren: 0 // Espera un poco antes de empezar el primer hijo
      }
    }
  };

  // Variante de cada tarjeta (Los músicos)
  const cardVariants = {
    // Estado inicial: invisible, un poco más abajo y pequeña
    hidden: { 
      opacity: 0, 
      y: 100, 
      scale: 0.8,
      rotateZ: 0 // Empiezan derechas antes de volar
    },
    // Estado final: usa los valores aleatorios (custom)
    visible: (customValues) => ({
      opacity: 1,
      y: customValues.yOffset,
      x: customValues.xOffset,
      scale: 1,
      rotateZ: customValues.rotation,
      transition: { 
        type: "spring", // Efecto de rebote suave al aterrizar
        damping: 15,
        stiffness: 100
      }
    })
  };

  return (
    <section className="nuestra-historia">
      <div className="story-content">
        <div className="header-seccion">
            <h1 className='blanco bold'>Nuestra historia</h1>
            <p className="text-md text-cursiva blanco">{INSPIRATIONAL_QUOTE}</p>
        </div>
        
        
        {/* Contenedor de la pila de fotos */}
        {/* 'viewport={{ once: true }}' asegura que la animación solo ocurra la primera vez que se hace scroll */}
        <motion.div 
          className="polaroid-stack"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 1 }} // amount 0.3: empieza cuando el 30% del elemento es visible
        >
          {storyPhotos.map((photo, index) => {
             // Obtenemos los valores aleatorios pre-calculados para esta foto
            const transformData = randomTransforms[index];
            const isLast = index === storyPhotos.length - 1;

            return (
              <motion.div 
                key={photo.id}
                className={`polaroid-card ${isLast ? 'top-card' : ''}`}
                variants={cardVariants}
                custom={transformData} // Pasamos los datos aleatorios a la variante
                style={{ zIndex: index }} // El orden natural del array define el apilamiento
              >
                <div className="polaroid-frame">
                  <img src={photo.src} alt={photo.caption} />
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>

      <BranchPath></BranchPath>

     
     
    </section>
  )
}

export default NuestraHistoria